import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { DefaultLayout } from 'src/components/layouts/DefaultLayout';
import { DefaultPageProps } from 'src/constants/Interface';
import StyleConfig from 'src/constants/StyleConfig';
import { LinkButton } from 'src/components/atoms/button/Button';
import PlainHomeButton from 'src/components/atoms/button/PlainHomeButton';

type Props = DefaultPageProps;

const ReservationCompletePage = (props: Props) => {
  return (
    <DefaultLayout {...props}>
      <Styled>
        <div>
          <Heading>＼ 事前予約注文の配信を承りました ／</Heading>
          <Lead>
            お客様には予約注文開始日時に
            <br />
            お知らせが配信されます。
            <br />
            予約配信履歴確認ページで
            <br />
            内容をご確認頂けます。
          </Lead>
          <Controller>
            <LinkButton
              isDisabled={false}
              buttonColor="green"
              url="/reservations/history"
              text={'配信内容を確認する'}
            />
            <PlainHomeButton />
          </Controller>
        </div>
      </Styled>
    </DefaultLayout>
  );
};

const Styled = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 52px);
`;

const Heading = styled.h3`
  color: ${StyleConfig.COLOR.PRIMARY};
  font-size: 18px;
  text-align: center;
`;
const Lead = styled.p`
  color: ${StyleConfig.COLOR.TEXT_COLOR};
  font-size: 14px;
  line-height: ${24 / 14};
  text-align: center;
  margin-top: 16px;
`;
const Controller = styled.div`
  margin-top: 40px;
  > * {
    margin-top: 16px;
  }
`;

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ReservationCompletePage);
